import {Sound} from '../../../shared/scripts/Sound'
import {UIStoreState} from '../../../shared/scripts/store/UIStoreState'
import {ClientUserState} from '../ClientUserState'
import {setElementInnerText} from '../ui_utils/DomUtils'

export class UIStoreMembershipTabsController {
    private readonly monthlyTab: HTMLDivElement
    protected readonly annualTab: HTMLDivElement

    constructor(storeState: UIStoreState) {
        this.monthlyTab = document.getElementById('store_page_membership_monthly_tab') as HTMLDivElement
        this.annualTab = document.getElementById('store_page_membership_annual_tab') as HTMLDivElement

        const discountString = UIStoreMembershipTabsController.getDiscountString()
        setElementInnerText(this.annualTab, {key: 'strings:storePage.membership.frequency.annual', options: {context: 'store', discount: `${discountString}`}})

        this.monthlyTab.addEventListener('click', () => {
            Sound.playSound(Sound.SoundType.Click)
            storeState.membershipToggleYearlyActive = false
        })

        this.annualTab.addEventListener('click', () => {
            Sound.playSound(Sound.SoundType.Click)
            storeState.membershipToggleYearlyActive = true
        })
    }

    setTabAnnual(annual: boolean) {
        if(annual) {
            this.monthlyTab.classList.remove('active')
            this.annualTab.classList.add('active')
            return
        }
        this.monthlyTab.classList.add('active')
        this.annualTab.classList.remove('active')
    }

    private static getDiscountString(): string {
        const defaultYearlyDiscount = 20
        const abTestYearlyDiscount = 43
        const isUserInTestGroup = ClientUserState.abTests.STORE_YEARLY_MEMBERSHIPS_PRICE_ADJUSTMENT != 'DEFAULT'
        const isUserAlreadyMember = ClientUserState.userState?.items.membership != undefined
        if(isUserAlreadyMember) return `${defaultYearlyDiscount}`
        if(isUserInTestGroup) return `${abTestYearlyDiscount}`
        return `${defaultYearlyDiscount}`
    }
}
